module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About The Author")]), _vm._v(" "), _c('p', [_vm._v("Dean M. King is an American author who lives with his wife, Kelly, and their son on Northeast Wisconsin’s Door Peninsula. He is a member of the Horror Writers Association and the Great Lakes Association of Horror Writers.")]), _vm._v(" "), _c('p', [_vm._v("Dean finds inspiration for his stories in remote areas of Wisconsin’s vast Northwoods, on the islands that lay off its coasts, and among the stalwart bluffs of Southwest Wisconsin. Whether Dean is writing about a dreadful creature that crawled from the Mississippi River or a drag race between a street-toughened hoodlum and the devil, you can be sure—maybe even a little afraid—that his stories will haunt you long after you read the final page.")]), _vm._v(" "), _c('p', [_vm._v("Dean has published several short stories in online and print venues. "), _c('em', [_vm._v("Sarah’s Cross")]), _vm._v(" is his first novel.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0